import { createLogic } from "redux-logic";
import firebase from "firebase/app";
import "firebase/firestore";

import * as ActionTypes from "../../actions/actionTypes";

const upsertFirebaseObject = createLogic({
	type: ActionTypes.UPSERT_FIREBASE_OBJECT,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		const user = { user: JSON.parse(JSON.stringify(getState().auth.user)) };
		const fbObject = Object.assign({}, action.object, user);
		firebase
			.firestore()
			.collection(action.objectType)
			.doc(action.id)
			.set(fbObject)
			.then(() => done());
	},
});

export default [upsertFirebaseObject];
